import Vue from 'vue'
import { app } from "../main.js";
import VueRouter from 'vue-router'
import {get, del, set } from "../utils/localStorage";
import { Message } from 'element-ui'
import store from '../store/index.js'
import request from '../utils/request'

// 路由懒加载
const _import = file => () =>
    import ('@/views/' + file + '/index.vue')
const routes = [{
        path: '/',
        name: 'Home',
        component: _import("Home")
    },
    {
        path: '/goods',
        name: 'goods',
        component: _import("Goods")
    },
    {
        path: '/goods/detail',
        name: 'goodsDetail',
        component: _import("GoodsDetail")
    },
    {
        path: '/new-goods',
        name: 'newGoods',
        component: _import("NewGoods")
    }, {
        path: '/activity',
        name: 'activity',
        component: _import("Activity")
    }, {
        path: '/activity/detail',
        name: 'activityDetail',
        component: _import("ActivityDetail")
    }, {
        path: '/share',
        name: 'share',
        component: _import("Share")
    }, {
        path: '/share/detail',
        name: 'shareDetail',
        component: _import("ShareDetail")
    }, {
        path: '/guide',
        name: 'guide',
        component: _import("Guide")
    }, {
        path: '/guide/detail',
        name: 'guideDetail',
        component: _import("GuideDetail")
    }, {
        path: '/register',
        name: 'register',
        component: _import("Register")
    }, {
        path: '/news-center',
        name: 'newsCenter',
        component: _import("NewsCenter")
    }, {
        path: '/edit-info',
        name: 'editInfo',
        component: _import("EditInfo")
    }, {
        path: '/favorite',
        name: 'favorite',
        component: _import("Favorite")
    }, {
        path: '/order',
        name: 'order',
        component: _import("Order")
    }, {
        path: '/order-detail',
        name: 'orderDetail',
        component: _import("OrderDetail")
    },
    {
        path: '/custom-order',
        name: 'customOrder',
        component: _import("CustomOrder")
    },
    {
        path: '/custom-reserve-order',
        name: 'customReserveOrder',
        component: _import("CustomReserveOrder")
    },
    {
        path: '/custom-order-detail',
        name: 'customOrderDetail',
        component: _import("CustomOrderDetail")
    },
    {
        path: '/user-center',
        name: 'userCenter',
        component: _import("UserCenter")
    },
    {
        path: '/location',
        name: 'location',
        component: _import("Location")
    },
    {
        path: '/custom-about',
        name: 'customAbout',
        component: _import("CustomAbout")
    },
    {
        path: '/custom-intro',
        name: 'customIntro',
        component: _import("CustomIntro")
    },
    {
        path: '/custom-form',
        name: 'customForm',
        component: _import("CustomForm")
    },
    {
        path: '/custom-history',
        name: 'customHistory',
        component: _import("CustomHistory")
    },
    {
        path: '/coupon',
        name: 'coupon',
        component: _import("Coupon")
    },
    {
        path: '/cart',
        name: 'cart',
        component: _import("Cart")
    },
    {
        path: '/coupon-rules',
        name: 'CouponRules',
        component: _import("CouponRules")
    },
    {
        path: '/forget',
        name: 'forget',
        component: _import("Forget")
    },
    {
        path: '/search',
        name: 'search',
        component: _import("Search")
    },
    {
        path: '/change-pwd',
        name: 'changePwd',
        component: _import("ChangePwd")
    },
    {
        path: '/Recommend',
        name: 'recommend',
        component: _import("Recommend")
    },
    {
        path: '/QAList',
        name: 'QAList',
        component: _import("QAList")
    },
    {
        path: '/QA/detail',
        name: 'QADetail',
        component: _import("QADetail")
    },
]

Vue.use(VueRouter)
const router = new VueRouter({
    routes
})

/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 作者：小米粒_
// 链接：https://juejin.cn/post/6858124427926863879
// 来源：掘金
// 著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。


// 管理需要登入的页面
const needLogin = ['newsCenter', 'editInfo', 'favorite', 'userCenter', 'customForm', 'cart', 'changePwd'];

router.beforeEach((to, from, next) => {
    // console.log('beforeEach');
    const token = get('token');
    // console.log('to', to);
    // console.log('from', from);

    // 判断是不是到登入页
    if (to.name == 'register') {
        // 如果登入的话跳到会员中心
        if (token) {
            router.push({ name: 'newsCenter' });
        } else {
            doNext(to, from, next);
        }
    }

    if (needLogin.includes(to.name)) {
        if (token) {
            // 藉由取得使用者资讯
            request({
                url: `/session?token=${token}`,
                method: 'post',
            }).then((userInfo) => {
                console.log(userInfo);
                // set('token', token);
                set('userInfo', userInfo);
                app.$store.commit('SET_USER_INFO', userInfo);
                doNext(to, from, next);
            })
        } else {
            // Message({
            //     message: "请先登入在执行此操作",
            //     type: 'error',
            //     duration: 3 * 1000
            // })

            if (from.name != 'register') {
                console.log('未登入被导到登入页面啦～～～～～');
                del('token');
                del('userInfo');
                // console.log('store', store);
                store.commit('CLEAN_USER_INFO');
                router.push({ name: 'register', query: { type: 'login' } });
            }
        }
    } else {
        doNext(to, from, next);
    }
});

// 跳转之前
// router.beforeResolve((to, form) => {})

// 跳转之后 例如把加载ui取消掉
router.afterEach((to, form) => {
    // console.log('afterEach');
    window.scrollTo(0, 0);
});

function doNext(to, from, next) {
    const token = get('token');
    const userInfo = get('userInfo');

    store.commit('CLOSE_MENU');
    // 如果没有store_id的话
    if (!to.query.store_id) {
        const query = to.query;

        // 如果from有store_id的话就拿来用
        if (from.query.store_id) {
            query.store_id = from.query.store_id;
        } else {
            // 有没有登入
            if (token) {
                // 使用帐号里面记录的store_id
                query.store_id = userInfo.user.store_id;
            } else {
                query.store_id = 1;
            }
        }
        // router.replace({ name: to.name, query });
        next({ name: to.name, query });
        return;
    }
    console.log('do next');
    next();
}

export default router